import { Base } from "../../framework/base";
var CalendarTaskCategoryListItem = /** @class */ (function () {
    function CalendarTaskCategoryListItem(obj) {
        this.id = obj && obj.id || "";
        this.companyId = obj && obj.companyId || "";
        this.databaseRecordType = obj === null || obj === void 0 ? void 0 : obj.databaseRecordType;
        this.code = obj && obj.code || "";
        this.color = obj && obj.color || "";
        this.comment = obj && obj.comment || "";
        this.sortOrder = obj && obj.sortOrder || 0;
        this.activeState = obj && obj.activeState || 0;
        this.isRemovable = Base.isNullOrUndefined(this.databaseRecordType);
    }
    CalendarTaskCategoryListItem.prototype.getHash = function () {
        return this.id + "#" + this.code + "#" + this.color + "#" + this.activeState.toString(10);
    };
    return CalendarTaskCategoryListItem;
}());
export { CalendarTaskCategoryListItem };
